var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opple-ota-progress"},[_c('p',{style:({ color: _vm.infoColor })},[_vm._v(" "+_vm._s(_vm.otaInfo)+" ")]),(_vm.isShowProgress)?_c('div',{staticClass:"ota_progress",staticStyle:{"margin-left":"0"}},[_c('el-progress',{attrs:{"percentage":_vm.progress,"color":_vm.customColor}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }